import { render } from "./LabelZeroField.vue?vue&type=template&id=9bc5d5d0"
import script from "./LabelZeroField.vue?vue&type=script&lang=js"
export * from "./LabelZeroField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__